import React from "react";
import {
  SignpostSplit,
  Cpu,
  ChatQuote
} from "react-bootstrap-icons";

const FinalCTA = () => {
  return (
    <section className="py-5" aria-labelledby="why-us-title">
      <div className="container">
        <div className="text-center mb-5">
          <span className="text-green-bbs fw-bold text-uppercase small tracking-wider">
            Deine Zukunft im Fokus
          </span>
          <h2 id="why-us-title" className="fw-bold text-gray-900 mt-1">
            Warum die BBS 2 Leer?
          </h2>
          <p className="text-muted mx-auto" style={{ maxWidth: "600px" }}>
            Wir bieten dir nicht nur eine schulische Heimat, sondern das
            perfekte Fundament für alles, was nach der Schule kommt.
          </p>
        </div>

        <div className="row g-4">
          {/* Argument 1: Durchlässigkeit & Abschlüsse */}
          <div className="col-12 col-md-4">
            <div className="card h-100 border-0 shadow-sm p-4 bg-white text-center">
              <div
                className="mx-auto rounded-circle d-flex align-items-center justify-content-center border mb-3"
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "rgba(40, 167, 69, 0.1)",
                  borderColor: "rgba(40, 167, 69, 0.2)",
                }}
              >
                {/* Nutzt das vorhandene SignpostSplit-Icon */}
                <SignpostSplit size={28} className="text-green-bbs" />
              </div>
              <h3 className="h5 fw-bold mb-2">
                Alle Abschlüsse unter einem Dach
              </h3>
              <p className="text-muted small mb-0 lh-base">
                Von der ersten beruflichen Orientierung bis zum höchsten
                Schulabschluss (Abitur). Bei uns stehen dir alle Wege offen –
                flexibel und perfekt auf deine Stärken abgestimmt.
              </p>
            </div>
          </div>

          {/* Argument 2: Innovation & Digitalkompetenz */}
          <div className="col-12 col-md-4">
            <div className="card h-100 border-0 shadow-sm p-4 bg-white text-center">
              <div
                className="mx-auto rounded-circle d-flex align-items-center justify-content-center border mb-3"
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "rgba(0, 213, 178, 0.1)",
                  borderColor: "rgba(0, 213, 178, 0.2)",
                }}
              >
                {/* Nutzt das vorhandene Cpu-Icon */}
                <Cpu size={28} style={{ color: "#00d5b2" }} />
              </div>
              <h3 className="h5 fw-bold mb-2">
                Ausgezeichnete Digitalkompetenz
              </h3>
              <p className="text-muted small mb-0 lh-base">
                Als zertifizierte Fobizz-Schule gestalten wir die Bildung der
                Zukunft. Moderne Medien, innovative Lernplattformen und digitale
                Fortbildung gehören bei uns fest zum Alltag.
              </p>
            </div>
          </div>

          {/* Argument 3: Gemeinschaft & Support */}
          <div className="col-12 col-md-4">
            <div className="card h-100 border-0 shadow-sm p-4 bg-white text-center">
              <div
                className="mx-auto rounded-circle d-flex align-items-center justify-content-center border mb-3"
                style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "rgba(111, 66, 193, 0.1)",
                  borderColor: "rgba(111, 66, 193, 0.2)",
                }}
              >
                {/* Nutzt das vorhandene ChatQuote-Icon */}
                <ChatQuote size={28} style={{ color: "#6f42c1" }} />
              </div>
              <h3 className="h5 fw-bold mb-2">
                Starke Gemeinschaft & Rückhalt
              </h3>
              <p className="text-muted small mb-0 lh-base">
                Du bist bei uns nicht einfach nur eine Nummer. Unser engagiertes
                Beratungsteam fängt dich bei Sorgen und Ängsten auf – für ein
                faires, sicheres und motivierendes Miteinander.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
